import Button from '../../../components/base/Button';

export default function CTASection() {
  return (
    <section className="py-16 bg-[#F2F2F2]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Header */}
        <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24] mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
          Transforme sua ideia em um projeto de alto padrão.
        </h2>
        
        {/* Content */}
        <div className="space-y-4 text-[#3F3F3F] leading-relaxed mb-8">
          <p>
            Se você busca um projeto arquitetônico premium, com design exclusivo, execução técnica impecável e atendimento personalizado, fale com a P&P Engenharia e Arquitetura.
          </p>
          
          <p>
            Nossa equipe está pronta para compreender sua visão e transformá-la em um espaço único.
          </p>
        </div>

        {/* CTA Button */}
        <a 
          href="https://api.whatsapp.com/send/?phone=5511980341891&text=Ol%C3%A1%21+Gostaria+de+saber+mais+sobre+os+servi%C3%A7os+da+P&type=phone_number&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium transition-all duration-300 cursor-pointer whitespace-nowrap inline-flex items-center justify-center bg-[#5C1A24] text-white hover:bg-[#4A1520] shadow-lg hover:shadow-xl px-8 py-3 text-base rounded-full"
        >
          <i className="ri-team-line mr-2"></i>
          Solicite uma reunião com nossa equipe
        </a>

        {/* Contact Info */}
        <div className="mt-8 pt-8 border-t border-gray-300">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div>
              <div className="w-12 h-12 bg-[#5C1A24] text-white rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-phone-line text-xl"></i>
              </div>
              <div className="text-sm text-[#3F3F3F] font-medium">Telefone</div>
              <div className="text-[#5C1A24] font-bold">(11) 98034-1891</div>
            </div>
            
            <div>
              <div className="w-12 h-12 bg-[#5C1A24] text-white rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <div className="text-sm text-[#3F3F3F] font-medium">E-mail</div>
              <div className="text-[#5C1A24] font-bold">pep.enarq@hotmail.com</div>
            </div>
            
            <div>
              <div className="w-12 h-12 bg-[#5C1A24] text-white rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-instagram-line text-xl"></i>
              </div>
              <div className="text-sm text-[#3F3F3F] font-medium">Instagram</div>
              <a href="https://www.instagram.com/p_pengenhariaearquitetura/" target="_blank" rel="noopener noreferrer" className="text-[#5C1A24] font-bold hover:underline cursor-pointer">
                @p_pengenhariaearquitetura
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
